import styled from 'styled-components';

export const BreadCrumberContainer = styled.div`
  .link-router {
    text-decoration: none;
    color: #004aa0;
    font-weight: 400;
    margin-bottom: 4px;

    transition: text-decoration 0.2s;

    &:hover {
      text-decoration: underline;
    }

    @media (max-width: 600px) {
      font-size: 12px;
    }

    @media (min-width: 601px) {
      font-size: 14px;
    }
  }
`;
